let Sentry;

async function getSentry() {
  if (!Sentry) Sentry = await import('@sentry/vue');
  return Sentry;
}

export { getSentry };